module.exports = __webpack_public_path__ + "img/ic_qmarker_handwash_cluster_issue.0a185767.png";